/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class PreventiveSheetService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'PreventiveSheetService\' loaded');
    }

    /**
     * Imports.
     *
     * @param {String} type Type of export.
     * @param {Object} data Data sent in the request body.
     * @returns {Promise} A promise providing the id of the file generated.
     */
    import(type, data) {
        const formData = new FormData();
        for (const property in data) {
            if (angular.isArray(data[property]) || (data[property] instanceof FileList)) {
                for (let i = 0; i < data[property].length; i++) {
                    formData.append(property, data[property][i]);
                }
            } else {
                formData.append(property, data[property]);
            }
        }
        return this.resource.import({type}, formData).$promise;
    }

    /**
     * Generate export.
     *
     * @param {String} type Type of export.
     * @param {Object} data Data sent in the request body.
     * @returns {Promise} A promise providing the id of the file generated.
     */
    generateExport(type, data) {
        return this.resource.generateExport({type}, data).$promise;
    }
}

export { PreventiveSheetService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/prevention/service/PreventiveSheetService.js